import angular from 'angular';
import constants from 'app/constants';
import controller from './impact-analysis-graph.controller';
import directive from './impact-analysis-graph.directive';


export default angular.module('app.components.advisory.bcp.impactAnalysisGraph', [
  constants,
])
  .directive('bcpImpactAnalysisGraph', directive)
  .controller('ImpactAnalysisGraphController', controller)
  .name;

console.log('app.components.advisory.bcp.impactAnalysisGraph created');
